import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IFootballOrganizerDTO } from "../../../../../api-services/football/admin/manage-football-organizer-service";
import { manageFootballOrganizerService } from "../../../../../commons";
import { StatusEnum } from "../../../../../commons/enums/status-enum";

export interface IFootballOrganizerEditOption {
  organizerId: number;
  organizerData: IFootballOrganizerDTO;
}

interface IFootballOrganizerEdit {
  footballOrganizerEditStatus: StatusEnum;
}

const initialState: IFootballOrganizerEdit = {
  footballOrganizerEditStatus: StatusEnum.Idle,
};

export const footballOrganizerEdit = createAsyncThunk(
  "manage/footballOrganizerEdit",
  async (options: IFootballOrganizerEditOption, thunkAPI) => {
    try {
      const footballOrganizerEditResponse = await manageFootballOrganizerService.editOrganizer(
        options.organizerId,
        options.organizerData
      );
      return footballOrganizerEditResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageFootballOrganizerEditSlice = createSlice({
  name: "footballOrganizerEdit",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(footballOrganizerEdit.pending, (state) => {
        state.footballOrganizerEditStatus = StatusEnum.Loading;
      })
      .addCase(footballOrganizerEdit.fulfilled, (state) => {
        state.footballOrganizerEditStatus = StatusEnum.Succeeded;
      })
      .addCase(footballOrganizerEdit.rejected, (state) => {
        state.footballOrganizerEditStatus = StatusEnum.Failed;
      });
  },
});

export default manageFootballOrganizerEditSlice.reducer;
